
function ButtonsRadio(props: any) {
  let options = props.options ?? [];
  let nameComponent = props.nameComponent ?? "";
  let value = props.value ?? "";
  let disabled = props.disabled ?? false;

  const onChangeRadioButton = (input: any) => {
    if (typeof props.onChange === "function") {
      props.onChange(input.target.value)
    }
  }

  return (
    <div className="ButtonsRadio">
      {options.map((option: any, key: number) => (
        <span key={key}>
          <input disabled={disabled} checked={value === option.value} onChange={onChangeRadioButton} type="radio" value={option.value} name={nameComponent} /> {option.name}
        </span>
      ))
      }
    </div>
  )
}

export default ButtonsRadio;